export default "__VITE_ASSET__DGLMXmVm__"